<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.title" placeholder="活动标题" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.type" clearable placeholder="类型">
            <el-option label="线上" value="online" />
            <el-option label="线下" value="offline" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.status" clearable placeholder="状态">
            <el-option label="草稿" value="draft" />
            <el-option label="已发布" value="published" />
            <el-option label="已关闭" value="closed" />
            <el-option label="已结束" value="ended" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新建活动</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table v-loading="listLoading" height="100%" :data="results" border stripe>
        <el-table-column prop="id" label="ID" width="90" />
        <el-table-column prop="title" label="标题" min-width="220" />
        <el-table-column prop="type" label="类型" width="90" />
        <el-table-column prop="status" label="状态" width="100" />
        <el-table-column prop="registeredCount" label="报名数" width="100" />
        <el-table-column prop="capacity" label="名额" width="90" />
        <el-table-column prop="startTime" label="开始时间" width="170">
          <template slot-scope="scope">{{ scope.row.startTime | formatDate }}</template>
        </el-table-column>
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="small" @click="openRegistrations(scope.row)">报名</el-button>
            <el-button size="small" @click="exportCsv(scope.row)">导出</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        :page-sizes="[20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>

    <el-dialog :visible.sync="formVisible" :title="form.id ? '编辑活动' : '新建活动'" width="720px">
      <el-form :model="form" label-width="110px">
        <el-form-item label="标题"><el-input v-model="form.title" /></el-form-item>
        <el-form-item label="简介"
          ><el-input v-model="form.description" type="textarea" :rows="3"
        /></el-form-item>
        <el-form-item label="活动详情">
          <mavon-editor
            v-model="form.detail"
            :toolbars="mdToolbars"
            :subfield="true"
            :default-open="'edit'"
            :box-shadow="false"
            :autofocus="false"
            placeholder="请使用 Markdown 编写活动详情"
            style="min-height: 420px"
          />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.type"
            ><el-option label="线上" value="online" /><el-option label="线下" value="offline"
          /></el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status">
            <el-option label="草稿" value="draft" />
            <el-option label="已发布" value="published" />
            <el-option label="已关闭" value="closed" />
            <el-option label="已结束" value="ended" />
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择开始时间"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择结束时间"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="报名截止">
          <el-date-picker
            v-model="form.registrationDeadline"
            type="datetime"
            value-format="timestamp"
            placeholder="选择报名截止时间"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="地点"><el-input v-model="form.location" /></el-form-item>
        <el-form-item label="名额"><el-input v-model.number="form.capacity" /></el-form-item>
        <el-form-item label="讨论链接"><el-input v-model="form.discussionUrl" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="registrationVisible" title="报名管理" width="900px">
      <el-table v-loading="registrationLoading" :data="registrations" border stripe>
        <el-table-column prop="registrationId" label="ID" width="90" />
        <el-table-column prop="name" label="姓名" width="120" />
        <el-table-column prop="contact" label="联系方式" />
        <el-table-column prop="status" label="状态" width="100" />
        <el-table-column prop="createTime" label="报名时间" width="170">
          <template slot-scope="scope">{{ scope.row.createTime | formatDate }}</template>
        </el-table-column>
        <el-table-column label="审核" width="220">
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="audit(scope.row, 'approved')"
              >通过</el-button
            >
            <el-button size="mini" type="danger" @click="audit(scope.row, 'rejected')"
              >拒绝</el-button
            >
            <el-button size="mini" @click="audit(scope.row, 'pending')">待审</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";

export default {
  name: "EventsAdmin",
  data() {
    return {
      mainHeight: "300px",
      listLoading: false,
      registrationLoading: false,
      submitLoading: false,
      results: [],
      registrations: [],
      page: {},
      filters: {},
      formVisible: false,
      form: {},
      mdToolbars: {
        bold: true,
        italic: true,
        header: true,
        underline: true,
        strikethrough: true,
        mark: true,
        quote: true,
        ol: true,
        ul: true,
        link: true,
        imagelink: true,
        code: true,
        table: true,
        fullscreen: true,
        preview: true,
        help: false,
        htmlcode: false,
        subfield: true,
        readmodel: true,
        undo: true,
        redo: true,
        trash: false,
        save: false,
        navigation: true,
        alignleft: false,
        aligncenter: false,
        alignright: false,
      },
      registrationVisible: false,
      activeEventId: 0,
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    list() {
      this.listLoading = true;
      const params = Object.assign({}, this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      this.axios
        .form("/api/admin/event/list", params)
        .then((data) => {
          this.results = data.results;
          this.page = data.page;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    handleAdd() {
      this.form = {
        status: "draft",
        type: "offline",
        startTime: Date.now(),
        endTime: Date.now() + 3600 * 1000,
        registrationDeadline: Date.now() + 1800 * 1000,
        capacity: 0,
      };
      this.formVisible = true;
    },
    handleEdit(row) {
      this.axios.get(`/api/admin/event/${row.id}`).then((data) => {
        this.form = Object.assign({}, data);
        this.formVisible = true;
      });
    },
    submitForm() {
      if (!this.form.title || !String(this.form.title).trim()) {
        this.$message.error("请填写活动标题");
        return;
      }
      if (!this.form.startTime || !this.form.endTime) {
        this.$message.error("请填写开始和结束时间");
        return;
      }
      if (this.form.status === "published" && !String(this.form.detail || "").trim()) {
        this.$message.error("发布活动前请填写活动详情");
        return;
      }
      if (Number(this.form.endTime) <= Number(this.form.startTime)) {
        this.$message.error("结束时间必须晚于开始时间");
        return;
      }
      if (!this.form.registrationDeadline) {
        this.$message.error("请填写报名截止时间");
        return;
      }
      if (Number(this.form.registrationDeadline) > Number(this.form.endTime)) {
        this.$message.error("报名截止时间不能晚于活动结束时间");
        return;
      }
      if (Number(this.form.capacity || 0) < 0) {
        this.$message.error("活动名额不能为负数");
        return;
      }
      this.submitLoading = true;
      const url = this.form.id ? "/api/admin/event/update" : "/api/admin/event/create";
      this.axios
        .form(url, this.form)
        .then(() => {
          this.$message.success("保存成功");
          this.formVisible = false;
          this.list();
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    openRegistrations(row) {
      this.activeEventId = row.id;
      this.registrationVisible = true;
      this.registrationLoading = true;
      this.axios
        .form("/api/admin/event/registrations", { event_id: row.id, page: 1, limit: 100 })
        .then((data) => {
          this.registrations = data.results || [];
        })
        .finally(() => {
          this.registrationLoading = false;
        });
    },
    audit(row, status) {
      this.axios
        .form("/api/admin/event/audit_registration", {
          registrationId: row.registrationId,
          status,
        })
        .then(() => {
          this.$message.success("审核完成");
          if (this.activeEventId) {
            this.openRegistrations({ id: this.activeEventId });
          }
        });
    },
    exportCsv(row) {
      window.open(`/api/admin/event/export_registrations/${row.id}`, "_blank");
    },
  },
};
</script>
